export const viewTransitionsApiAvailable = ('startViewTransition' in document && typeof document.startViewTransition === 'function');
